import { render } from "./Wallets.vue?vue&type=template&id=47f955ff&scoped=true"
import script from "./Wallets.vue?vue&type=script&lang=js"
export * from "./Wallets.vue?vue&type=script&lang=js"

import "./Wallets.vue?vue&type=style&index=0&id=47f955ff&scoped=true&lang=css"

import exportComponent from "F:\\ssd_backup\\OpenServer\\domains\\paygate.admin-panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f955ff"]])

export default __exports__